<template>
<div id="serveRecd">
  <router-view></router-view>
</div>
</template>

<script>
export default {
  name: 'serveRecd'
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/serveRecd/index.vue